export enum ContactUse {
  home = "HOME",
  work = "WORK",
  temp = "TEMP",
  mobile = "MOBILE",
  // old = "OLD",
}
